import client from '../client'

export async function changeFinancialPreferences({ annualMileage }) {
  return client(
    `${process.env.NEXT_PUBLIC_PURCHASE_DOMAIN}/api/UserAccounts/ChangeFinancialPreferences`,
    {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        financialPreferences: {
          annualMileage,
        },
      }),
    },
  )
}
